module.exports = __webpack_public_path__ + "img/mccree.9ba9cc4a.png";